import Button from 'devextreme-react/button';
import ScrollView from 'devextreme-react/scroll-view';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Tab } from 'semantic-ui-react';
import { mauThuKetQuaApi } from '../../../../api/mauThuKetQuaApi';
import HtmlView from '../../../../components/html-view/HtmlView';
import { useCommonContext } from '../../../../contexts/common';
import { showNotify } from '../../../../helpers/toast';
import styles from "../noi-dung-thu-modal/NoiDungModal.module.css";
import NoiDungThuENModal from './NoiDungThuENModal';
import NoiDungThuVNModal from './NoiDungThuVNModal';


const NoiDungModal = ({ onSuccess, onCancel, letterTemplate, dm_truong_id }) => {
    const { translate } = useCommonContext();
    const { nam_hoc } = useSelector((x) => x.namHoc);
    const { dm_coso_id } = useSelector((x) => x.coSo);
    const [isLoading, setIsLoading] = useState(false);
    const [htmlElementName, setHtmlElementName] = useState("noi_dung_vn");
    const [isShowHtmlEditorVNModal, setisShowHtmlEditorVNModal] = useState();
    const [isShowHtmlEditorENModal, setisShowHtmlEditorENModal] = useState();
    const [isCollapseVNModal, setisCollapseVNModal] = useState(false);
    const [isCollapseENModal, setisCollapseENModal] = useState(true);
    const [isAttachResult, setIsAttachResult] = useState(true);
    const [letter, setLetter] = useState(letterTemplate || {
        id: 0,
        dm_coso_id: dm_coso_id,
        dm_truong_id: dm_truong_id,
        nam_hoc: nam_hoc,
        noi_dung_vn: '',
        body_params_vn: '',
        noi_dung_en: '',
        body_params_en: '',
        dinh_kem_ket_qua_thi: true
    });

    useEffect(() => {
        onSuccess(letter);
    }, [letter])


    const handleCollapseVN = () => {
        setisCollapseVNModal(!isCollapseVNModal)
    }
    const handleCollapseEN = () => {
        setisCollapseENModal(!isCollapseENModal)
    }
    const handleSaveChanges = async () => {
        if (letter.id > 0) {
            setIsLoading(true)
            const res = await mauThuKetQuaApi.Update(letter);
            setIsLoading(false)
            if (res.is_success) {
                showNotify({ text: "Cập nhật thành công", type: "success" })
                onSuccess();
            } else {
                showNotify({ text: "Có lỗi", type: "error" })

            }
        } else {
            setIsLoading(true)
            const res = await mauThuKetQuaApi.Insert(letter);
            setIsLoading(false)
            if (res.is_success) {
                showNotify({ text: "Thêm mới thành công", type: "success" })
                onSuccess();
            } else {
                showNotify({ text: "Có lỗi", type: "error" })

            }
        }
    }
    const panes = [
        {
            menuItem: translate(`NỘI DUNG TIẾNG VIỆT`),
            render: () => (
                <Tab.Pane>
                    <div>
                        <div className={styles.editorContent}>
                            {(!letter.noi_dung_vn || letter.noi_dung_vn === "") &&
                                <Button
                                    text='Nhập nội dung'
                                    stylingMode='text'
                                    type='default'
                                    onClick={() => {
                                        setHtmlElementName("noi_dung_vn")
                                        setisShowHtmlEditorVNModal(true)
                                    }}
                                />}
                            <HtmlView value={letter.noi_dung_vn} height={"auto"} onFocusIn={() => {
                                setHtmlElementName("noi_dung_vn")
                                setisShowHtmlEditorVNModal(true)
                            }} />
                        </div>
                    </div>

                </Tab.Pane>
            ),
        },
        {
            menuItem: translate(`NỘI DUNG TIẾNG ANH`),
            render: () => (
                <Tab.Pane>
                    <div className='padding-top-1rem'>
                        <div className={styles.editorContent}>
                            {(!letter.noi_dung_en || letter.noi_dung_en == "") &&
                                <Button
                                    text='Nhập nội dung'
                                    stylingMode='text'
                                    type='default'
                                    onClick={() => {
                                        setHtmlElementName("noi_dung_en")
                                        setisShowHtmlEditorENModal(true)
                                    }}
                                />}
                            <HtmlView value={letter.noi_dung_en} height={"auto"} onFocusIn={() => {
                                setHtmlElementName("noi_dung_en")
                                setisShowHtmlEditorENModal(true)
                            }} />
                        </div>

                    </div>
                </Tab.Pane >
            ),
        },
    ];
    return (
        <div className='row'>
            <ScrollView height={window.innerHeight - 340}>

                {/* <Modal
                open={true}
                size="large"
                dimmer={'blurring'}
                onClose={onCancel}
                closeOnEscape={false}
                closeOnDimmerClick={false}
            >
                <Modal.Header>
                    <p>{translate('Nội dung thư chia sẻ')}</p>
                </Modal.Header>
                <Modal.Content> */}
                {/* <ScrollView height={window.innerHeight - 250}>
                        <div className='row'>
                            <div className='col-md-12 padding-2rem'>
                                <Checkbox
                                    defaultChecked={letter.dinh_kem_ket_qua_thi}
                                    onChange={() => setLetter({ ...letter, dinh_kem_ket_qua_thi: !letter.dinh_kem_ket_qua_thi })}
                                    label={<label>{translate('Đính kèm kết quả thi')}</label>}
                                />
                            </div>

                            <div className='col-md-12 padding-left-2rem'>
                                <div>
                                    <label style={{ fontWeight: 600, fontSize: '14px' }}>Nội dung (Việt Nam)</label>
                                    {isCollapseVNModal &&
                                        <i className="fas fa-chevron-up" style={{ cursor: 'pointer' }} onClick={() => { handleCollapseVN() }}></i>}
                                    {!isCollapseVNModal &&
                                        <i className="fas fa-chevron-down" style={{ cursor: 'pointer' }} onClick={() => { handleCollapseVN() }}></i>}
                                    <div className={styles.editorContent}>
                                        {(!letter.noi_dung_vn || letter.noi_dung_vn === "") &&
                                            <Button
                                                text='Nhập nội dung'
                                                stylingMode='text'
                                                type='default'
                                                onClick={() => {
                                                    setHtmlElementName("noi_dung_vn")
                                                    setisShowHtmlEditorVNModal(true)
                                                }}
                                            />}
                                        {isCollapseVNModal &&
                                            <HtmlView value={letter.noi_dung_vn} height={"auto"} onFocusIn={() => {
                                                setHtmlElementName("noi_dung_vn")
                                                setisShowHtmlEditorVNModal(true)
                                            }} />}
                                    </div>
                                </div>

                                <div className='padding-top-1rem'>
                                    <label style={{ fontWeight: 600, fontSize: '14px' }}>Nội dung (English)</label>
                                    {isCollapseENModal &&
                                        <i className="fas fa-chevron-up" style={{ cursor: 'pointer' }} onClick={() => { handleCollapseEN() }}></i>}
                                    {!isCollapseENModal &&
                                        <i className="fas fa-chevron-down" style={{ cursor: 'pointer' }} onClick={() => { handleCollapseEN() }}></i>}
                                    <div className={styles.editorContent}>
                                        {(!letter.noi_dung_en || letter.noi_dung_en == "") &&
                                            <Button
                                                text='Nhập nội dung'
                                                stylingMode='text'
                                                type='default'
                                                onClick={() => {
                                                    setHtmlElementName("noi_dung_en")
                                                    setisShowHtmlEditorENModal(true)
                                                }}
                                            />}
                                        {isCollapseENModal &&
                                            <HtmlView value={letter.noi_dung_en} height={"auto"} onFocusIn={() => {
                                                setHtmlElementName("noi_dung_en")
                                                setisShowHtmlEditorENModal(true)
                                            }} />
                                        }
                                    </div>

                                </div>
                            </div>
                        </div>
                    </ScrollView> */}

                <div className='col-md-12 padding-top-1rem'>
                    {/* <div  className='col-md-12 padding-top-1rem'>
                            <CheckBox
                                defaultChecked={letter.dinh_kem_ket_qua_thi}
                                onChange={() => setLetter({ ...letter, dinh_kem_ket_qua_thi: !letter.dinh_kem_ket_qua_thi })}
                                label={<label>{translate('Đính kèm kết quả thi')}</label>}
                            />
                        </div> */}

                    <Tab panes={panes} />
                </div>
            </ScrollView>

            {/* </Modal.Content>
                <Modal.Actions> */}
            {/* <div>
                <DefaultButton text={"Đóng"} onClick={() => {
                    onCancel();
                }} />
                <PrimaryButton
                    onClick={handleSaveChanges}
                    text="Cập nhật"
                    isLoading={isLoading} />

            </div> */}
            {/* </Modal.Actions>
            </Modal> */}
            {isShowHtmlEditorVNModal &&
                <NoiDungThuVNModal
                    value={letter.noi_dung_vn}
                    onClose={() => { setisShowHtmlEditorVNModal(false) }}
                    onSuccess={(value) => {
                        setisShowHtmlEditorVNModal(false);
                        if (htmlElementName == "noi_dung_vn") {
                            setLetter({ ...letter, noi_dung_vn: value })
                        }
                    }}
                />
            }
            {isShowHtmlEditorENModal &&
                <NoiDungThuENModal
                    value={letter.noi_dung_en}
                    onClose={() => { setisShowHtmlEditorENModal(false) }}
                    onSuccess={(value) => {
                        setisShowHtmlEditorENModal(false);
                        if (htmlElementName == "noi_dung_en") {
                            setLetter({ ...letter, noi_dung_en: value })
                        }
                    }}
                    isLoading={isLoading}
                />
            }
        </div>
    );
};
export default NoiDungModal;
